import { render, staticRenderFns } from "./DocMasterUpload.vue?vue&type=template&id=628fbfb2&scoped=true&"
import script from "./DocMasterUpload.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocMasterUpload.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocMasterUpload.vue?vue&type=style&index=0&id=628fbfb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fbfb2",
  null
  
)

export default component.exports